import { Stack, styled } from "@mui/material";
import { HeadingXL } from "../Typography";

export const BannerWrapper = styled(Stack)(({ theme }) => ({
    justifyContent: "space-between",
    height: 95,
    padding: theme.spacing(3),
    border: "1px solid",
    borderColor: theme.palette.grey.light,
    borderRadius: theme.spacing(2),

    [theme.breakpoints.down("md")]: {
        height: "auto",
        padding: theme.spacing(4),
        flexDirection: "column",
    },

    [theme.breakpoints.up("md")]: {
        flexDirection: "row",
    },
}));

export const ButtonContainer = styled(Stack)(({ theme }) => ({
    marginTop: theme.spacing(4),
    textAlign: "center",
    textWrap: "nowrap",
    "& button": {
        [theme.breakpoints.down("md")]: {
            width: "100%",
        },
        [theme.breakpoints.up("md")]: {
            width: "auto",
        },
    },

    [theme.breakpoints.up("md")]: {
        marginRight: theme.spacing(4),
    },
}));

export const HeadingContainer = styled(HeadingXL)({
    marginBottom: 0,
});

export const HighlightedText = styled("span")(({ theme }) => ({
    ...theme.typography.h1,
    display: "inline",
    marginBottom: 0,
    color: theme.palette.primary.dark,
}));

export const InlineText = styled("span")(({ theme }) => ({
    ...theme.typography.h1,
    display: "inline",
    marginBottom: 0,
}));

export const ImageContainer = styled(Stack)(() => ({
    height: "100%",
    "& img": {
        height: "100%",
        objectFit: "contain",
    },
}));
